// 域名配置映射
export const domainMap = {
    'aipay': {
        name: '艾之付',
        icpNo: '京ICP备2023005565号-1'
    },
    'stkj': {
        name: '晟支付',
        icpNo: '粤ICP备2025487505号'
    },
};

// 根据域名获取配置的辅助函数
export const getDomainConfig = (domain) => {
    for (const [domainPattern, config] of Object.entries(domainMap)) {
        if (domain.includes(domainPattern) || domain === domainPattern) {
            return config;
        }
    }
    return domainMap.aipay;
};